/* eslint-disable vars-on-top, prefer-const, no-prototype-builtins */

function jumpToSection() {
    $(document).ready(function() {

        // Dropdown Select.
        var dropdownParent = jQuery( '.js-jump-to-section-select-wrap' );

        $('.js-jump-to-section-select').select2({
            placeholder:             "Select Section",
            dropdownParent:          dropdownParent,
            minimumResultsForSearch: -1,
        });

        function addOptionToSelect(optionValue, optionText) {
            var $select = $('.js-jump-to-section-select');
            var newOption = new Option(optionText, optionValue, false, false);

            $select.append(newOption).trigger('change'); // Trigger 'change' event to update Select2
        }

        function scrollToSection(sectionId, topOffset = 0) {
            var offset = $(sectionId).offset().top - topOffset;
            $('html, body').animate({ scrollTop: offset }, 100);
        }

        // Fill List.
        var contentBeforeBanner = '.js-content-before-banner';
        var contentAfterBanner = '.js-content-after-banner';
        //var titlesList = $( contentBeforeBanner + ', ' + contentAfterBanner).find( 'h1, h2, h3, h4, h5' );
        var titlesList = $( contentBeforeBanner + ', ' + contentAfterBanner).find( 'h1, h2' );
        
        if ( 0 === titlesList.length ) {
            jQuery( '.js-jump-to-section-wrap' ).remove();
        }

        for ( var key in titlesList ) {

            if (titlesList.hasOwnProperty(key)) {

                let titleText =  titlesList[key].textContent;
                let sectionId = 'section-' + key;
                let innerHTML = '<li><a href="#' + sectionId + '" class="js-jump-to-section-link">' + titleText + '</a></li>';
    
                if( titleText ) {
                    jQuery( '.js-jump-to-section' ).append( innerHTML );
                    $( titlesList[key] ).attr('id', sectionId);

                    addOptionToSelect( sectionId, titleText );
                }

            }

        }

        // Click Actions.
        $('.js-jump-to-section-select').on('change', function() {
            var selectedOption = $(this).val();

            if (selectedOption) {
                scrollToSection( '#' + selectedOption, 80 );
            }
        });

        $(document).on('click', '.js-jump-to-section a', function(e){
            e.preventDefault();

            let sectionId = $(this).attr('href');

            scrollToSection( sectionId, 80 );
        });
        
    });
}

jumpToSection();
